module.exports = __webpack_public_path__ + "img/background.3cb1c398.jpg";